<cfp-card [title]="'header.roadmap-module' | translate" [useH1]="useH1()" [titleId]="'roadmapTableTitle'" id="roadmap">
  <span afterTitle>&nbsp;<ng-content select="[title-content]" /></span>
  @let buildingIdValue = buildingId();
  @if (!loading() && !errorMessage()) {
    <div actions class="col-auto d-print-none d-flex justify-content-start align-items-center action-group">
      @if (buildingIdValue) {
        @defer (when showOwnershipStatus) {
          <cfp-ownership-status-toggle [buildingId]="buildingIdValue" />
        }
        @defer (when hasAILicense() && isMeasuresRoadmap()) {
          <cfp-ai-building-roadmap-button
            [buildingId]="buildingIdValue"
            [currentLang]="currentLang()"
            (predict)="predict.emit($event)"
            [predicting]="predicting()"
            (predictingChange)="predictingChange.emit($event)"
          />
        }
      }
      @if (showLabelGroup()) {
        <cfp-select-label-group
          [labelGroup]="labelGroup()"
          [dataTest]="'roadmapTableLabelGroupSelect'"
          [name]="'roadmapTableLabelGroupSelect'"
        />
      }
      @if (showDropdown()) {
        <cfp-dropdown
          [icon]="'ellipsis-v'"
          [ariaLabel]="'show' | translate"
          [formControlSize]="'small'"
          class="cfp-dropdown-options"
          [id]="'switchScenarios'"
        >
          <div class="dropdown-title">{{ 'show' | translate }}</div>
          <cfp-input-radio
            [radioValue]="'investment'"
            [name]="'show'"
            [id]="'showInvestment'"
            [ngModel]="showProperty()"
            (ngModelChange)="setShowProperty('investment')"
            [label]="'businesscase.investment' | translate"
          />
          <cfp-input-radio
            [radioValue]="'costReduction'"
            [name]="'show'"
            [id]="'showCostReduction'"
            [ngModel]="showProperty()"
            (ngModelChange)="setShowProperty('costReduction')"
            [label]="'costReduction' | translate"
          />
          <cfp-input-radio
            [radioValue]="'co2ConsumptionReduction'"
            [name]="'show'"
            [id]="'showCo2ConsumptionReduction'"
            [ngModel]="showProperty()"
            (ngModelChange)="setShowProperty('co2ConsumptionReduction')"
            [label]="'businesscase.co2reduction' | translate"
          />
          @if (showEnergyLabel()) {
            <cfp-input-radio
              [radioValue]="'energyLabel'"
              [name]="'show'"
              [id]="'showEnergyLabels'"
              [ngModel]="showProperty()"
              (ngModelChange)="setShowProperty('energyLabels')"
              [label]="'energyLabel' | translate"
            />
          }
          @if (!isBuildingRoadmap() && showImplementedMeasuresToggle()) {
            <div class="dropdown-title">{{ 'settings' | translate }}</div>
            <cfp-input-checkbox
              [id]="'measuresBuildingRoadmapToggle'"
              [label]="'toggleCompletedMeasuresBuildingRoadmap' | translate"
              [formControl]="toggleSwitchCompletedMeasures"
            />
          }
          @if (showExportToExcel() || showRoadmapImageExport()) {
            <div class="dropdown-title">{{ 'export' | translate }}</div>
            @if (showExportToExcel()) {
              <button type="button" (click)="export()" class="dropdown-item cursor-pointer">
                <cfp-icon [icon]="'file-excel'" [classes]="'me-2'" />
                {{ 'export.excel' | translate }}
              </button>
            }
            @if (showRoadmapImageExport()) {
              <button type="button" (click)="exportToPng()" class="dropdown-item cursor-pointer">
                <cfp-icon [icon]="'file-image'" [classes]="'me-2'" />
                {{ 'export.png' | translate }}
              </button>
              <button type="button" (click)="exportToJpg()" class="dropdown-item cursor-pointer">
                <cfp-icon [icon]="'file-image'" [classes]="'me-2'" />
                {{ 'export.jpg' | translate }}
              </button>
            }
          }
        </cfp-dropdown>
      } @else {
        <cfp-dropdown-select
          liveRegionStatusUpdater
          [alignMenuRight]="true"
          [statusUpdateOnClick]="'roadmapTable.liveAreaRegion.' + showProperty() | translate"
          [ngModel]="showProperty()"
          (ngModelChange)="setShowProperty($event)"
          [id]="'manageTableColumns'"
          [ariaLabel]="'roadmapTable.ariaLabel.manageTableColumns' | translate"
        >
          <cfp-dropdown-option [value]="'investment'" [label]="'businesscase.investment'" />
          <cfp-dropdown-option [value]="'costReduction'" [label]="'costReduction'" />
          <cfp-dropdown-option [value]="'co2ConsumptionReduction'" [label]="'businesscase.co2reduction'" />
          @if (!this.environment.hideRoadmapTotalEnergyConsumptionReductionInKwh) {
            <cfp-dropdown-option
              [value]="'totalEnergyConsumptionReductionInKwh'"
              [label]="'roadmap.totalEnergyConsumptionReductionInKwh'"
            />
          }
          @if (showEnergyLabel()) {
            <cfp-dropdown-option [value]="'energyLabels'" [label]="'rating'" />
          }
        </cfp-dropdown-select>

        @if (showM2Toggle()) {
          <cfp-button-toggle
            [id]="'roadmapTableShowM2'"
            liveRegionStatusUpdater
            [statusUpdateOnClick]="'liveAreaRegion.contentUpdatedBelow' | translate"
            [pressed]="showM2()"
            (clicked)="showM2.set(!showM2())"
            [dataTest]="'portfolioShowPerAreaButton'"
            [ariaLabel]="'aria.label.toggleSquareUnit' | translate"
          >
            <cfp-measurement-area />
          </cfp-button-toggle>
        }
        @if (showDesktopOptionsDropdown()) {
          <cfp-dropdown
            [icon]="'ellipsis-v'"
            [ariaLabel]="'show' | translate"
            class="cfp-dropdown-options"
            [id]="'switchScenarios'"
            [autoClose]="false"
          >
            @if (!isBuildingRoadmap() && showImplementedMeasuresToggle()) {
              <div class="dropdown-title">{{ 'settings' | translate }}</div>
              <cfp-input-checkbox
                [id]="'measuresBuildingRoadmapToggleDesktop'"
                [label]="'toggleCompletedMeasuresBuildingRoadmap' | translate"
                [formControl]="toggleSwitchCompletedMeasures"
              />
            }
            @if (showExportToExcel() || showRoadmapImageExport()) {
              <div class="dropdown-title">{{ 'export' | translate }}</div>
              @if (showExportToExcel()) {
                <button type="button" (click)="export()" class="dropdown-item cursor-pointer">
                  <cfp-icon [icon]="'file-excel'" [classes]="'me-2'" />
                  {{ 'export.excel' | translate }}
                </button>
              }
              @if (showRoadmapImageExport()) {
                <button type="button" (click)="exportToPng()" class="dropdown-item cursor-pointer">
                  <cfp-icon [icon]="'file-image'" [classes]="'me-2'" />
                  {{ 'export.png' | translate }}
                </button>
                <button type="button" (click)="exportToJpg()" class="dropdown-item cursor-pointer">
                  <cfp-icon [icon]="'file-image'" [classes]="'me-2'" />
                  {{ 'export.jpg' | translate }}
                </button>
              }
            }
          </cfp-dropdown>
        }
      }
    </div>
  }

  <ng-content select="[intro-content]" />

  @if (canChangeUserDefinedEnergyLabel()) {
    <div class="mb-4">
      @if (inChangeEnergyLabelMode()) {
        <cfp-button (clicked)="energyLabelSave.emit()" [classes]="'me-2'">{{ 'save.button' | translate }}</cfp-button>
        <cfp-button
          (clicked)="energyLabelCancel.emit()"
          [classes]="'me-2'"
          [style]="'secondary'"
          [buttonOutline]="true"
          >{{ 'cancel.button' | translate }}</cfp-button
        >
        @if (canResetUserDefinedEnergyLabel()) {
          <cfp-button (clicked)="energyLabelReset.emit()" [style]="'secondary'" [buttonOutline]="true">{{
            'roadmap.changeEnergyLabels.reset' | translate
          }}</cfp-button>
        }
      } @else {
        <cfp-button (clicked)="energyLabelEdit.emit()" [style]="'secondary'" [buttonOutline]="true">{{
          'roadmap.changeEnergyLabels' | translate
        }}</cfp-button>
      }
    </div>
  }
  @let rowsValue = rows();
  @if (!loading() && years() && totals() && !errorMessage()) {
    <div
      class="table-container table-columns-sticky roadmap-table-container"
      [style.overflow-x]="
        (showNoRowsContent() && rowsValue && rowsValue.length === 0) || predicting() ? 'hidden' : 'auto'
      "
      #tableContainer
      tableStickyHeader
    >
      <table
        class="table table-striped roadmap-table"
        [class.roadmap-table-energy-label-in-row]="showEnergyLabelInRow()"
        #table
        data-test="roadmapTable"
        aria-labelledby="roadmapTableTitle"
      >
        <span class="sr-only">{{ 'aria.table.headerWithButtonsAllowSort' | translate }}</span>
        <thead [class.d-none]="headerHidden()">
          <tr>
            <th scope="col" class="can-sort" [attr.aria-sort]="getAriaSort()">
              @if (leftColumnName() === 'displayAddress') {
                <button type="button" (click)="sort('orderByAddress')">
                  {{ 'building' | translate }}
                  <cfp-sort-icon [active]="sortColumnName() === 'orderByAddress'" [sortDescending]="sortDescending()" />
                </button>
              } @else if (leftColumnName() === 'name') {
                <button type="button" (click)="sort('name')">
                  {{ (showEnergyLabelInRow() ? 'roadmap.investment' : 'measure') | translate }}
                  <cfp-sort-icon
                    [active]="sortColumnName() === 'name'"
                    [sortDescending]="sortDescending()"
                    [defaultSortDescending]="true"
                  />
                </button>
              }
            </th>
            @for (year of years(); track $index) {
              <th
                class="can-sort year"
                scope="col"
                [style.min-width]="`${thWidth()}px`"
                [attr.aria-sort]="getAriaSort(year.year)"
              >
                <button
                  [attr.aria-label]="`${('sort' | translate)} ${year.year ? year.year : ('noYear' | translate)}`"
                  type="button"
                  (click)="sort(showProperty(), year.year || -1)"
                >
                  <span class="d-inline-block">{{ year.year ? year.year : ('noYear' | translate) }}</span>
                  <cfp-sort-icon
                    [active]="isSortActive(year.year || -1)"
                    [sortDescending]="sortDescending()"
                    [defaultSortDescending]="true"
                  />
                  @if (showEnergyLabelInRow()) {
                    <div class="w-100">
                      <ng-container
                        *ngTemplateOutlet="
                          yearLabel;
                          context: {
                            year: year
                          }
                        "
                      />
                    </div>
                  } @else {
                    <ng-container
                      *ngTemplateOutlet="
                        yearLabel;
                        context: {
                          year: year
                        }
                      "
                    />
                  }
                </button>
              </th>
            }
          </tr>
        </thead>
        <tbody>
          @let leftColumnNameValue = leftColumnName();
          @for (row of rowsValue; track getRowTrackKey(row)) {
            @let measureRow = mapToBuildingMeasureTableItemDTOWithYearData(row);
            @let buildingRow = mapToRoadmapPortfolioBuildingDetailsDTO(row);
            <tr [id]="'roadmapTableRow' + $index">
              <th
                [class.cursor-pointer]="!readOnly()"
                [attr.aria-labelledby]="'roadmapTableRow' + $index"
                scope="row"
                class="roadmap-table-measure-header-item align-items-center"
                [class.show-dropdown]="focusIndex() === $index"
                (focusin)="setFocusIndex($index)"
                (mouseenter)="setFocusIndex($index)"
                (focusout)="clearFocusIndex($event)"
                (mouseleave)="clearFocusIndex($event)"
              >
                <button
                  [attr.aria-label]="
                    leftColumnNameValue === 'displayAddress' ? buildingRow.displayAddress?.join(', ') : measureRow.name
                  "
                  class="roadmap-table-measure-item"
                  (click)="onRowClick(row, $index)"
                >
                  @if (leftColumnNameValue === 'displayAddress') {
                    <cfp-building-address
                      class="td-content"
                      [buildingId]="buildingRow.id"
                      [address]="buildingRow.displayAddress ?? []"
                      [size]="'sm'"
                    />
                  }
                  @if (leftColumnNameValue === 'name') {
                    @let measureIconClass = getMeasureIconClass(measureRow);
                    <div
                      class="td-content"
                      lineClampDetector
                      [lineClampTarget]="'.overflow-hidden'"
                      [lineClampContent]="'cfp-text-wrap-with-content'"
                      [lineClampIcon]="measureIconClass ? '.fa' : undefined"
                    >
                      <div class="overflow-hidden" [title]="measureRow.name">
                        <cfp-text-wrap-with-content [text]="measureRow.name">
                          @if (measureIconClass) {
                            <span
                              [class]="measureIconClass"
                              [title]="
                                getMeasureTitle(measureRow)
                                  | translate: { year: measureRow.implementationYear || ('unknown' | translate) }
                              "
                            ></span>
                          }
                        </cfp-text-wrap-with-content>
                      </div>
                    </div>
                  }
                </button>

                @if (
                  canChangeRoadmap() &&
                  !this.environment.hideRoadmapMeasureStatusAction &&
                  focusIndex() === $index &&
                  leftColumnNameValue === 'name'
                ) {
                  <cfp-measure-status-action-dropdown
                    [measure]="measureRow"
                    (saveStatus)="saveMeasureStatus($event)"
                    (click)="openMeasureStatusDropdown($index, $event)"
                    (closed)="measureStatusDropdownClosed()"
                  />
                }
              </th>
              @let showCellButtonValue = showCellButton();
              @for (year of years(); track $index) {
                @let yearData = getYearData(measureRow, year.year);
                <td [class.skeleton-loader]="predicting()">
                  <button
                    type="button"
                    class="td-content position-relative"
                    [disabled]="!canChangeRoadmap()"
                    [tooltip]="
                      yearData && measureRow.predictedReasoning ? (measureRow.predictedReasoning | translate) : null
                    "
                    [container]="'body'"
                    [placement]="'top'"
                    [adaptivePosition]="false"
                    [class.cursor-default]="!showCellButtonValue"
                    (keyup.enter)="
                      canChangeRoadmap() && onCellClick($event, { row: row, year: year, property: showProperty() })
                    "
                    (click)="
                      canChangeRoadmap() && onCellClick($event, { row: row, year: year, property: showProperty() })
                    "
                    [attr.aria-label]="showCellButtonValue ? getCellButtonAriaLabel(row, year.year) : undefined"
                    [attr.tabindex]="showCellButtonValue ? undefined : -1"
                  >
                    @if (yearData || (!year.year && showProperty() === 'energyLabels')) {
                      <ng-container
                        *ngTemplateOutlet="
                          propertyValue;
                          context: {
                            value: yearData?.[showProperty()] ?? null,
                            row: row,
                            year: year.year
                          }
                        "
                      />
                    }
                    @if (shouldShowCellButtonTitle(year, measureRow)) {
                      <span class="btn btn-sm btn-light"> {{ getCellButtonTitle(year.year) | translate }} </span>
                    }
                  </button>
                </td>
              }
            </tr>
          }
          @if (showNoRowsContent() && rowsValue.length === 0) {
            <tr class="roadmap-table-no-rows">
              <th></th>
              <td [attr.colspan]="years().length">
                <div
                  class="roadmap-table-no-rows-wrapper d-none d-lg-block"
                  [style.width.px]="tableContainerWidth()"
                >
                  <div class="roadmap-table-no-rows-content">
                    <ng-content select="[no-rows-content]" />
                  </div>
                </div>
              </td>
            </tr>
          }
          @if (canChangeRoadmap() && showAddRow()) {
            <tr class="d-print-none roadmap-table-add-row">
              <th>
                <div class="td-content">
                  <ng-content select="[add-row-content]" />
                </div>
              </th>
              @for (year of years(); track $index) {
                <td>
                  <div class="td-content"></div>
                </td>
              }
            </tr>
          }
        </tbody>
        @if (rowsValue && rowsValue.length > 0 && showProperty() !== 'energyLabels') {
          <tfoot>
            <tr>
              <th [innerHTML]="'roadmap.total.' + showProperty() | translate"></th>
              @for (year of years(); track year) {
                <th>
                  <div class="td-content">
                    @if (year.year && totals()[year.year]) {
                      <ng-container
                        *ngTemplateOutlet="propertyValue; context: { value: totals()[year.year][showProperty()] }"
                      />
                    }
                  </div>
                </th>
              }
            </tr>
          </tfoot>
        }
      </table>
    </div>
    <ng-content select="[bottom-content]" />
  } @else {
    <cfp-loading-spinner [loading]="!errorMessage()" [error]="!!errorMessage()" [errorMessage]="errorMessage()" />
  }
</cfp-card>

<ng-template #propertyValue let-value="value" let-untypedRow="row" let-year="year">
  @let row = mapToRoadmapPortfolioBuildingDetailsDTO(untypedRow);
  @let measureRow = mapToBuildingMeasureTableItemDTOWithYearData(untypedRow);
  @switch (showProperty()) {
    @case ('energyLabels') {
      @let energyLabelsValue = mapToEnergyLabels(value);
      @if (labelGroup(); as labelGroupValue) {
        @if (year && energyLabelsValue[labelGroupValue]) {
          <cfp-energy-label class="mx-auto" [energyLabel]="energyLabelsValue[labelGroupValue]" [size]="'sm'" />
        } @else if (
          row &&
          !year &&
          row.energyLabels[labelGroupValue]?.currentEnergyLabel &&
          row.energyLabels[labelGroupValue]?.improvedEnergyLabel
        ) {
          <div class="w-100 d-flex align-items-center justify-content-between">
            <cfp-energy-label
              class="d-inline-block"
              [energyLabel]="row.energyLabels[labelGroupValue].currentEnergyLabel"
              [size]="'xs'"
            />
            <i aria-hidden="true" class="fa fa-chevron-right"></i>
            <cfp-energy-label
              class="d-inline-block"
              [energyLabel]="row.energyLabels[labelGroupValue].improvedEnergyLabel"
              [size]="'xs'"
            />
          </div>
        }
      }
    }
    @case ('co2ConsumptionReduction') {
      <span
        [class.text-can-edit]="measureRow && measureRow.cols?.[year] && cellClickEmitter.observed"
        class="text-overflow-ellipsis"
      >
        @if (value) {
          @if (showM2()) {
            <cfp-measurement-mass-per-square [value]="value" [addCo2]="false" />
          } @else {
            <span [innerHtml]="value | co2: false : true"></span>
          }
        } @else {
          -
        }
      </span>
    }
    @case ('totalEnergyConsumptionReductionInKwh') {
      <span
        [class.text-can-edit]="measureRow && measureRow.cols?.[year] && cellClickEmitter.observed"
        class="text-overflow-ellipsis"
      >
        @if (value) {
          @if (showM2()) {
            <cfp-measurement-kwh-per-square [value]="value" [addBreak]="true" />
          } @else {
            {{ value | number: '1.0-0' }} kWh
          }
        } @else {
          -
        }
      </span>
    }
    @default {
      <span
        [class.text-can-edit]="measureRow && measureRow.cols?.[year] && cellClickEmitter.observed"
        class="text-overflow-ellipsis"
      >
        @if (value) {
          @if (showM2()) {
            <cfp-measurement-cost-per-square [value]="value" [sourceCurrencyCode]="currencyCode()!" />
          } @else {
            {{ value | cfpCurrency: currencyCode()! : undefined : '1.0-0' }}
          }
        } @else {
          -
        }
      </span>
    }
  }
</ng-template>

<ng-template #yearLabel let-year="year">
  @let roadmapBuildingYear = mapToRoadmapBuildingYearDTO(year);
  @if (labelGroup(); as labelGroupValue) {
    @let energyLabelValue = roadmapBuildingYear.energyLabels?.[labelGroupValue];
    @if (year.year && inChangeEnergyLabelMode()) {
      <cfp-dropdown-select
        (click)="$event.preventDefault(); $event.stopPropagation()"
        [disabled]="saving()"
        [ngModel]="energyLabelValue?.label"
        (ngModelChange)="energyLabelChange.emit({ year: year.year, label: $event })"
        [formControlSize]="'small'"
        [classes]="'w-auto mt-1'"
        [container]="'body'"
      >
        @for (label of manualEnergyLabels; track label) {
          <cfp-dropdown-option [value]="label" [label]="label || ''" />
        }
        <ng-template #optionTemplate let-option="option">
          <div class="p-1">
            @if (option?.value()) {
              <cfp-energy-label [energyLabel]="{ label: option.value() }" [size]="'xs'" [displayFlex]="true" />
            } @else {
              {{ 'empty' | translate }}
            }
          </div>
        </ng-template>
      </cfp-dropdown-select>
    } @else if (energyLabelValue) {
      <cfp-energy-label
        liveRegionStatusUpdater
        [statusUpdateOnShow]="
          'roadmap.ariaLiveRegion.showEnergyLabelTableHeader'
            | translate: { label: energyLabelValue.label, year: year.year }
        "
        [statusUpdateOnHide]="
          'roadmap.ariaLiveRegion.hideEnergyLabelTableHeader'
            | translate: { label: energyLabelValue.label, year: year.year }
        "
        [showStatusUpdates]="canUpdateAriaStatus()"
        class="year-label"
        [energyLabel]="energyLabelValue"
        [size]="'xs'"
      />
    }
  }
</ng-template>
